import script from "./NewsPageFullView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageFullView.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageFullView.vue?vue&type=style&index=0&id=72d48bf4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72d48bf4"]])

export default __exports__